var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "stone-expanded-row row" }, [
    _c("div", { staticClass: "col-md-4" }, [
      _c("div", { ref: "imageIframe" }, [
        _vm.selectedStone.diamond
          ? _c("div", { staticClass: "stone-image-div" }, [
              _vm.selectedStone.diamond.image &&
              !_vm.selectedStone.diamond.video
                ? _c("img", {
                    staticClass: "w-100 rounded-border",
                    attrs: { src: _vm.selectedStone.diamond.image }
                  })
                : _vm._e(),
              _vm.selectedStone.diamond.video
                ? _c("iframe", {
                    staticClass: "rounded-border",
                    attrs: {
                      scrolling: "no",
                      height: _vm.iframeSize,
                      width: _vm.iframeSize,
                      src: _vm.selectedStone.diamond.video
                    }
                  })
                : _vm._e(),
              !_vm.selectedStone.diamond.image &&
              !_vm.selectedStone.diamond.video
                ? _c("img", {
                    staticClass: "w-100 rounded-border",
                    attrs: {
                      src: require("../assets/diamond_placeholder.jpeg")
                    }
                  })
                : _vm._e()
            ])
          : _vm._e()
      ])
    ]),
    _c("div", { staticClass: "col-md-8" }, [
      _c("div", { staticClass: "row m-0" }, [
        _c("div", { staticClass: "col-6 col-md-4" }, [
          _c("span", { staticClass: "feature-label" }, [
            _vm._v(_vm._s(_vm.$t("stones.shape")))
          ]),
          _c("span", { staticClass: "feature-value" }, [
            _vm._v(_vm._s(_vm.selectedStone.diamond.certificate.shape))
          ])
        ]),
        _c("div", { staticClass: "col-6 col-md-4" }, [
          _c("span", { staticClass: "feature-label" }, [
            _vm._v(_vm._s(_vm.$t("stones.carat")))
          ]),
          _c("span", { staticClass: "feature-value" }, [
            _vm._v(_vm._s(_vm.selectedStone.diamond.certificate.carats))
          ])
        ]),
        _c("div", { staticClass: "col-6 col-md-4" }, [
          _c("span", { staticClass: "feature-label" }, [
            _vm._v(_vm._s(_vm.$t("stones.cut")))
          ]),
          _c("span", { staticClass: "feature-value" }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "stones.quality." + _vm.selectedStone.diamond.certificate.cut
                )
              )
            )
          ])
        ]),
        _c("div", { staticClass: "col-6 col-md-4" }, [
          _c("span", { staticClass: "feature-label" }, [
            _vm._v(_vm._s(_vm.$t("stones.color")))
          ]),
          _c("span", { staticClass: "feature-value" }, [
            _vm._v(_vm._s(_vm.selectedStone.color))
          ])
        ]),
        _c("div", { staticClass: "col-6 col-md-4" }, [
          _c("span", { staticClass: "feature-label" }, [
            _vm._v(_vm._s(_vm.$t("stones.clarity")))
          ]),
          _c("span", { staticClass: "feature-value" }, [
            _vm._v(_vm._s(_vm.selectedStone.diamond.certificate.clarity))
          ])
        ]),
        _c("div", { staticClass: "col-6 col-md-4" }, [
          _c("span", { staticClass: "feature-label" }, [
            _vm._v(_vm._s(_vm.$t("stones.polish")))
          ]),
          _c("span", { staticClass: "feature-value" }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "stones.quality." +
                    _vm.selectedStone.diamond.certificate.polish
                )
              )
            )
          ])
        ]),
        _c("div", { staticClass: "col-6 col-md-4" }, [
          _c("span", { staticClass: "feature-label" }, [
            _vm._v(_vm._s(_vm.$t("stones.symmetry")))
          ]),
          _c("span", { staticClass: "feature-value" }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "stones.quality." +
                    _vm.selectedStone.diamond.certificate.symmetry
                )
              )
            )
          ])
        ]),
        _c("div", { staticClass: "col-6 col-md-4" }, [
          _c("span", { staticClass: "feature-label" }, [
            _vm._v(_vm._s(_vm.$t("stones.fluorescence")))
          ]),
          _c("span", { staticClass: "feature-value" }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "stones.fluorescence." +
                    _vm.selectedStone.diamond.certificate.floInt
                )
              )
            )
          ])
        ]),
        _c("div", { staticClass: "col-6 col-md-4" }, [
          _c("span", { staticClass: "feature-label" }, [
            _vm._v(_vm._s(_vm.$t("stones.measurements")))
          ]),
          _c("span", { staticClass: "feature-value" }, [
            _vm._v(_vm._s(_vm.getMeasurements()))
          ])
        ]),
        _c("div", { staticClass: "col-6 col-md-4" }, [
          _c("span", { staticClass: "feature-label" }, [
            _vm._v(_vm._s(_vm.$t("stones.lwRatio")))
          ]),
          _c("span", { staticClass: "feature-value" }, [
            _vm._v(
              _vm._s(
                _vm._f("number")(
                  _vm.selectedStone.diamond.certificate.length /
                    _vm.selectedStone.diamond.certificate.width,
                  "0.00"
                )
              )
            )
          ])
        ]),
        _c("div", { staticClass: "col-6 col-md-4" }, [
          _c("span", { staticClass: "feature-label" }, [
            _vm._v(_vm._s(_vm.$t("stones.table")))
          ]),
          _c("span", { staticClass: "feature-value" }, [
            _vm._v(
              _vm._s(
                _vm._f("number")(
                  _vm.selectedStone.diamond.certificate.table,
                  "0.00"
                )
              ) + "%"
            )
          ])
        ]),
        _c("div", { staticClass: "col-6 col-md-4" }, [
          _c("span", { staticClass: "feature-label" }, [
            _vm._v(_vm._s(_vm.$t("stones.depth")))
          ]),
          _c("span", { staticClass: "feature-value" }, [
            _vm._v(
              _vm._s(
                _vm._f("number")(
                  _vm.selectedStone.diamond.certificate.depthPercentage,
                  "0.00"
                )
              ) + "%"
            )
          ])
        ]),
        _c("div", { staticClass: "col-6 col-md-4" }, [
          _c("span", { staticClass: "feature-label" }, [
            _vm._v(_vm._s(_vm.$t("stones.certificateLab")))
          ]),
          _c("span", { staticClass: "feature-value" }, [
            _vm._v(
              _vm._s(
                _vm.selectedStone.diamond.certificate.lab +
                  (_vm.selectedStone.diamond.certificate.pdfUrl
                    ? " " + _vm.selectedStone.diamond.certificate.certNumber
                    : "")
              )
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "row m-0" }, [
        _c("div", { staticClass: "col-md-6 d-flex" }, [
          _vm.selectedStone.diamond.certificate.pdfUrl
            ? _c(
                "button",
                {
                  staticClass: "btn more-info-btn",
                  on: {
                    click: function($event) {
                      return _vm.openCertificate(
                        _vm.selectedStone.diamond.certificate.pdfUrl
                      )
                    }
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("uppercase")(_vm.$t("stones.certificateLab"))
                      ) +
                      " "
                  )
                ]
              )
            : _vm._e()
        ]),
        _c("div", { staticClass: "col-md-6" }, [
          !_vm.buildYourJewelMode || _vm.showBuildYourJewelPrice()
            ? _c("div", { staticClass: "price-div" }, [
                _c("div", { staticClass: "w-100 text-left" }, [
                  _vm.retailPerc == 1 &&
                  _vm.credential.apiEncryptedUse &&
                  !_vm.showBuildYourJewelPrice()
                    ? _c("span", { staticClass: "discount" }, [
                        _vm._v(" " + _vm._s(_vm.$t("stones.discount")) + " ")
                      ])
                    : _vm._e(),
                  _vm.buildYourJewelMode
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.$t("build_your_jewel.jewel_price")))
                      ])
                    : _vm._e(),
                  !_vm.buildYourJewelMode
                    ? _c("span", [_vm._v(_vm._s(_vm.$t("jewelValue")))])
                    : _vm._e()
                ]),
                _c("div", { staticClass: "w-100 text-right" }, [
                  _vm.retailPerc == 1 &&
                  _vm.credential.apiEncryptedUser &&
                  !_vm.showBuildYourJewelPrice()
                    ? _c("span", { staticClass: "discount" }, [
                        _vm._v(
                          _vm._s(
                            -Math.abs(_vm.selectedStone.discount) / 100 + "%"
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm.buildYourJewelMode
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("from") + " ") +
                            " " +
                            _vm._s(
                              _vm._f("currency")(
                                _vm.selectedStone.buildYourJewelPrice *
                                  _vm.retailPerc *
                                  _vm.vat
                              )
                            )
                        )
                      ])
                    : _vm._e(),
                  !_vm.buildYourJewelMode
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("currency")(
                              _vm.selectedStone.cartItem.singleAmount *
                                _vm.retailPerc *
                                _vm.vat
                            )
                          )
                        )
                      ])
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          !_vm.buildYourJewelMode
            ? _c("div", { staticClass: "planned-shipment" }, [
                _c("div", { staticClass: "w-100 text-left" }, [
                  _vm._v(_vm._s(_vm.$t("plannedShipment")))
                ]),
                _c("div", { staticClass: "w-100 text-right" }, [
                  _vm._v(_vm._s(_vm.selectedStone.cartItem.deliveryDate))
                ])
              ])
            : _vm._e(),
          !_vm.buildYourJewelMode
            ? _c(
                "button",
                {
                  staticClass: "btn add-to-cart-btn",
                  class: [
                    _vm.row.addedToBasket
                      ? "btn-secondary-" + _vm.theme
                      : "btn-primary-" + _vm.theme
                  ],
                  attrs: { disabled: _vm.row.addedToBasket },
                  on: { click: _vm.addToBasket }
                },
                [
                  _vm.row.addedToBasket
                    ? _c("span", {}, [_vm._v(_vm._s(_vm.$t("addedToBasket")))])
                    : _c("span", {}, [
                        _vm._v(_vm._s(_vm.$t("addToBasket")) + " ")
                      ])
                ]
              )
            : _vm._e(),
          _vm.buildYourJewelMode
            ? _c(
                "button",
                {
                  staticClass: "btn add-to-cart-btn",
                  on: {
                    click: function($event) {
                      return _vm.selectStone(_vm.selectedStone)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("build_your_jewel.selectStone")))]
              )
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }